import React, { Component } from 'react';
import { get } from '../services/api';
import Loading from './Loading/Loading';
import PowerfulTable from './PowerfulTable/PowerfulTable';

export default class PaymentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            payments: null,
            filteredPayments: null,
            filter: '',
            statusFilter: 'all'
        };
    }

    componentDidMount() {
        this.fetchPayments();
    }

    fetchPayments = async () => {
        // 1. Initial load
        const initialPayments = await get(`/admin/transactions?limit=50`);
        if (initialPayments) {
            const formatted = this.formatPayments(initialPayments);
            this.setState({
                payments: formatted,
                filteredPayments: formatted,
                filter: ''
            });
        }

        // 2. Background load
        get(`/admin/transactions?limit=10000&skip=50`).then(rest => {
            if (rest && rest.length > 0) {
                this.setState(prevState => {
                    const existingIds = new Set((prevState.payments || []).map(p => p.paymentId));
                    const newUnique = this.formatPayments(rest).filter(p => !existingIds.has(p.paymentId));
                    const all = [...(prevState.payments || []), ...newUnique];
                    return {
                        payments: all,
                        filteredPayments: all
                    };
                }, () => {
                    if (this.state.filter || this.state.statusFilter !== 'all') {
                        this.applyFilter(this.state.filter, this.state.statusFilter);
                    }
                });
            }
        });
    }

    formatPayments = (payments) => {
        return payments.map(p => ({
            paymentId: p.paymentId,
            user: p.subscription?.user?.email || p.user?.email || 'N/A',
            amount: Number(p.amountPaid).toFixed(2),
            status: p.transactionStatus,
            transactionId: p.transactionId || '-',
            date: new Date(p.paymentDatetime).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            }),
            rawDate: p.paymentDatetime
        }));
    }

    applyFilter = (term, status) => {
        const s = term.toLowerCase();
        let filtered = this.state.payments;

        if (status !== 'all') {
            filtered = filtered.filter(p => p.status === status);
        }

        if (s) {
            filtered = filtered.filter((p) => {
                const searchStr = (p.paymentId + p.user + p.transactionId + p.status).toLowerCase();
                return searchStr.includes(s);
            });
        }

        this.setState({ filteredPayments: filtered });
    }

    filter = (event) => {
        const s = event.target.value;
        this.setState({ filter: s });
        this.applyFilter(s, this.state.statusFilter);
    }

    handleStatusFilter = (event) => {
        const status = event.target.value;
        this.setState({ statusFilter: status });
        this.applyFilter(this.state.filter, status);
    }

    getStatusStyle = (status) => {
        switch (status) {
            case 'CONFIRMED':
                return { backgroundColor: '#d4edda', color: '#155724', padding: '2px 8px', borderRadius: 4 };
            case 'PENDING':
                return { backgroundColor: '#fff3cd', color: '#856404', padding: '2px 8px', borderRadius: 4 };
            case 'FAILED':
                return { backgroundColor: '#f8d7da', color: '#721c24', padding: '2px 8px', borderRadius: 4 };
            default:
                return {};
        }
    }

    render() {
        const { filteredPayments, filter, statusFilter } = this.state;
        if (!filteredPayments) return <Loading />;

        // Calculate stats
        const confirmed = filteredPayments.filter(p => p.status === 'CONFIRMED');
        const totalAmount = confirmed.reduce((acc, p) => acc + parseFloat(p.amount), 0);

        return (
            <div style={{ marginLeft: 20 }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                    <h2>Paiements ({filteredPayments.length})</h2>

                    <div style={{ display: 'flex', gap: 15, alignItems: 'center' }}>
                        <div style={{
                            backgroundColor: '#d4edda',
                            color: '#155724',
                            padding: '8px 15px',
                            borderRadius: 8,
                            fontWeight: 'bold'
                        }}>
                            Total confirmé: {totalAmount.toFixed(2)}€
                        </div>

                        <select
                            value={statusFilter}
                            onChange={this.handleStatusFilter}
                            style={{
                                padding: '8px 15px',
                                borderRadius: 8,
                                border: '1px solid #ccc',
                                backgroundColor: '#fff'
                            }}
                        >
                            <option value="all">Tous les statuts</option>
                            <option value="CONFIRMED">Confirmés</option>
                            <option value="PENDING">En attente</option>
                            <option value="FAILED">Échoués</option>
                        </select>

                        <input
                            placeholder='Rechercher...'
                            type='text'
                            onChange={this.filter}
                            value={filter}
                            style={{
                                paddingLeft: 10,
                                width: 180,
                                height: 30,
                                borderRadius: 30,
                                boxShadow: 'none',
                                borderStyle: 'hidden',
                                backgroundColor: '#eee',
                                outline: 'none'
                            }}
                        />
                    </div>
                </div>

                <PowerfulTable
                    data={filteredPayments}
                    types={{
                        paymentId: { name: 'ID' },
                        user: { name: 'Utilisateur' },
                        amount: { name: 'Montant (€)' },
                        status: { name: 'Statut' },
                        transactionId: { name: 'Transaction BNP' },
                        date: { name: 'Date' },
                    }}
                />
            </div>
        );
    }
}
